angular.module('v3sWbtPlayerApp').factory('v3sPageService', ['v3sServiceFinder', 'v3sExerciseService', 'v3sExtensionsConfig', 'v3sI18nService', 'v3sNavigationService', function (v3sServiceFinder, v3sExerciseService, v3sExtensionsConfig, v3sI18nService, v3sNavigationService) {

    var v3sSelectionService = null,
        v3sInteractionService = null,
        v3sTimelineService = null,
        v3sConditionService = null,
        v3sMediaService = null,
        v3sUserService = null,
        v3sResumeService = null;

    var page = null,
        sco = null,
        testSco = null,
        test = null,
        wbt = null,
        scope = null;

    function init(pScope) {
        v3sSelectionService = v3sServiceFinder.get("v3sSelectionService");
        v3sInteractionService = v3sServiceFinder.get("v3sInteractionService");
        v3sTimelineService = v3sServiceFinder.get("v3sTimelineService");
        v3sConditionService = v3sServiceFinder.get("v3sConditionService");
        v3sMediaService = v3sServiceFinder.get("v3sMediaService");
        v3sUserService = v3sServiceFinder.get("v3sUserService");
        v3sResumeService = v3sServiceFinder.get("v3sResumeService");

        page = pScope.currentPage;
        sco = pScope.sco;
        testSco = pScope.testSco;
        test = pScope.test;
        wbt = pScope.wbt;
        scope = pScope;

        // Für identisches Verhalten innerhalb und außerhalb der LMS
        if (page.isTrackable()) {
            page.incomplete();
        } else if (sco.isTrackable()) {
            sco.incomplete();
        } else {
            wbt.incomplete();
        }

        if (page.isInfo()) {
            if (v3sTimelineService) {
                v3sTimelineService.subscribeCompleted(scope, function () {
                    if(!!page) page.complete();
                });
            } else {
                page.complete();
            }
        }

        if (v3sConditionService) v3sConditionService.init(scope);
        if (v3sResumeService) v3sResumeService.resume(scope);
    }

    function getProgress(item, format) {
        var value = "0";

        var progress = item.getProgress();

        if (format == "progress") {
            value = progress.completed + "/" + progress.count;
        } else if (progress.count > 0) {
            value = Math.floor(progress.completed * 100 / progress.count);
        }

        return value;
    };

    function formatScore(score) {
        return parseInt(score);
    };

    function getValue(key) {
        var value = null;

        if (!!scope) {
            var keyPart = key.split(".");

            if (keyPart[0] == "user") {
                value = v3sUserService.get(keyPart[1]);

            } else if (keyPart[0] == "others") {
                if (keyPart[1] == "currentDate") { value = v3sI18nService.getDate(); }
                if (keyPart[1] == "currentTime") { value = v3sI18nService.getTime(); }


            } else if (!!keyPart[0]) {
                var item = v3sNavigationService.getItem(keyPart[0]);

                if (!!item) {
                    if (item == wbt) {
                        if (keyPart[1] == "title") { value = v3sI18nService.getText(wbt.title); }
                        else if (keyPart[1] == "description") { value = v3sI18nService.getText(wbt.description); }
                        else if (keyPart[1] == "version") { value = v3sI18nService.getText(wbt.version); }
                    } else if (item.getTest && item.getTest() == test) {
                        if (keyPart[1] == "completedStatus" || keyPart[1] == "lastCompletedStatus") { value = v3sI18nService.getText("general.status." + testSco.getStatus()); }
                        else if (keyPart[1] == "date") { value = test.getLastAccess() > 0 ? v3sI18nService.getDate(test.getLastAccess()) : ""; }
                        else if (keyPart[1] == "time") { value = test.getLastAccess() > 0 ? v3sI18nService.getTime(test.getLastAccess()) : ""; }
                        else if (keyPart[1] == "attempt") { value = test.getAttempt(); }
                        else if (keyPart[1] == "masteryscore") { value = testSco.getMasteryscore(); }
                        else if (keyPart[1] == "passedStatus") { value = v3sI18nService.getText("general.status." + testSco.getExerciseStatus()); }
                        else if (keyPart[1] == "lastScore") { value = formatScore(test.getScore()); }
                        else if (keyPart[1] == "lastCorrectExercises") { value = Math.round(test.getAllMaxExercises() * test.getScore() / 100); }
                        else if (keyPart[1] == "lastWrongExercises") { value = Math.round(test.getAllMaxExercises() * (100 - test.getScore()) / 100); }
                        else if (keyPart[1] == "lastPassedStatus") { value = v3sI18nService.getText("general.status." + test.getExerciseStatus()); }
                        else if (keyPart[1] == "exerciseIndex") { value = test.getIndexOfQuestion(scope.currentPage); }
                    }

                    if (value === null) { // page oder Eigenschaft gilt für alle Items
                        if (keyPart[1] == "completedStatus") { value = v3sI18nService.getText("general.status." + item.getStatus()); }
                        else if (keyPart[1] == "passedStatus") { value = v3sI18nService.getText("general.status." + item.getExerciseStatus()); }
                        else if (keyPart[1] == "progress" || keyPart[1] == "percentProgress") { value = getProgress(item, keyPart[1]); }
                        else if (keyPart[1] == "score") { value = formatScore(item.getScore()); }
                        else if (keyPart[1] == "progress" || keyPart[1] == "percentProgress") { value = getProgress(item, keyPart[1]); }
                        else if (keyPart[1] == "scoreExercises" || keyPart[1] == "exercises" || keyPart[1] == "correctExercises" || keyPart[1] == "wrongExercises") {
                            var exerciseStatistic = item.getExerciseStatistic();
                            if (keyPart[1] == "scoreExercises") { value = formatScore(exerciseStatistic.score); }
                            else if (keyPart[1] == "exercises") { value = exerciseStatistic.count; }
                            else if (keyPart[1] == "correctExercises") { value = exerciseStatistic.correct; }
                            else if (keyPart[1] == "wrongExercises") { value = exerciseStatistic.wrong; }
                        }
                    }
                    if (value == "general.status.") {
                        value = "";
                    }
                }
            }
        }

        return value !== null ? value : "";
    }

    function addElement(element, callbacks) {
        if (v3sSelectionService) v3sSelectionService.addElement(element, callbacks);
        if (v3sInteractionService) v3sInteractionService.addElement(element);
    }

    function destroy() {
        if (!!scope) {
            v3sExerciseService.destroy();

            if (v3sExtensionsConfig.enablePageAlwaysCompleted && !(!!test && test.isRunning())) {
                page.complete();
            }
            if (v3sConditionService) v3sConditionService.destroy();
            if (v3sSelectionService) v3sSelectionService.destroy();
            if (v3sMediaService) v3sMediaService.destroy();
            if (v3sUserService)v3sUserService.hideUserData();
            page.clean();

            page = null;
            sco = null;
            testSco = null;
            test = null;
            wbt = null;
            scope = null;
        }
    }
    
    return {
        init: init,
        destroy: destroy,
        getValue: getValue,
        addElement: addElement
    }
}]);